import store from "../index";

const state = {
    languages : window.APPDATA.languages,
};

const mutations = {
    SET(state, languageId) {
        state.languages = _.map(state.languages, (language) => {
            language.is_selected = languageId==language.id;

            return language;
        });
    },
};


const actions = {
    set({ commit, state }, params) {

        store.dispatch('loader/pending');

        commit('SET', params.lang);
        this._vm.$cookies.set('lang', params.lang, '6y', null, null, true, 'Lax');
        document.location.reload();

        return new Promise((resolve, reject) => {
            resolve();
        });

        /*return this._vm.$http.post(this.getters.urls.api.language, params).then((response) => {
            if(response.data.status) {
                document.location.reload();
            }

            return response; //to epistrefo gia na peksi to then sto dispatch
        });*/
    },
};

const getters = {
    all(state, getters, rootState) {
        return state.languages;
    },
    selected(state, getters, rootState) {
        return _.find(state.languages, ['is_selected', true]);
    },
    selectedId(state, getters, rootState) {
        return _.get(getters.selected, 'id', 'el');
    },
};

export default {
    state,
    actions,
    getters,
    mutations,
}